import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { cva } from 'class-variance-authority';
import { Loader2Icon } from 'lucide-react';
import { Slot } from 'radix-ui';
import { cn } from "../../lib/utils.js";
const buttonVariants = cva("inline-flex shrink-0 cursor-pointer items-center justify-center gap-2 rounded-lg text-base font-semibold whitespace-nowrap transition-[color,background-color,box-shadow] outline-none select-none focus-visible:ring-[3px] focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50 aria-invalid:ring-destructive [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-5", {
    variants: {
        variant: {
            default: 'bg-primary text-primary-foreground shadow-sm hover:bg-primary/90 active:bg-primary/85',
            highlight: 'bg-highlight text-highlight-foreground shadow-sm hover:bg-highlight/90 active:bg-highlight/85',
            secondary: 'bg-secondary text-secondary-foreground hover:bg-accent',
            outline: 'border border-input bg-background text-foreground hover:bg-accent hover:text-accent-foreground',
            ghost: 'text-foreground hover:bg-accent hover:text-accent-foreground',
            destructive: 'bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90 active:bg-destructive/85',
            link: 'h-auto px-0 text-primary underline underline-offset-4 hover:decoration-2',
        },
        size: {
            sm: 'h-9 gap-1.5 px-3 text-sm',
            default: 'h-11 px-5',
            lg: 'h-12 px-6 text-lg',
            icon: 'size-11',
            'icon-sm': 'size-9',
        },
    },
    defaultVariants: { variant: 'default', size: 'default' },
});
function Button({ className, variant = 'default', size = 'default', asChild = false, loading = false, loadingLabel = 'Cargando', disabled, children, ...props }) {
    const Comp = asChild ? Slot.Root : 'button';
    return (_jsx(Comp, { "data-slot": "button", "data-variant": variant, "data-size": size, className: cn(buttonVariants({ variant, size, className })), disabled: disabled === true || loading, "aria-busy": loading || undefined, ...props, children: loading && !asChild ? (_jsxs(_Fragment, { children: [_jsx(Loader2Icon, { className: "animate-spin", "aria-hidden": "true" }), _jsx("span", { className: "sr-only", children: loadingLabel }), children] })) : (children) }));
}
export { Button, buttonVariants };
//# sourceMappingURL=button.js.map